import React, { useState, useEffect } from 'react';
import { Card, Spin, Alert, Button, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import api from '../../../services/api';

// 导入各个游戏的配置组件
import ARKConfig from './ARKConfig';

interface GameConfigProps {
  serverId: string;
  gameType: string;
  serverInfo?: any;
  onTabChange?: (tabKey: string) => void;
}

interface GameTypeInfo {
  id: number;
  name: string;
  display_name: string;
  description: string;
  supports_mods: boolean;
  is_steam_game: boolean;
  steam_app_id?: number;
}

const GameConfig: React.FC<GameConfigProps> = ({ serverId, gameType, serverInfo, onTabChange }) => {
  const [loading, setLoading] = useState(true);
  const [gameTypeInfo, setGameTypeInfo] = useState<GameTypeInfo | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadGameTypeInfo();
  }, [gameType]);

  const loadGameTypeInfo = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // 检查gameType是否有效
      if (!gameType || gameType === 'undefined' || gameType === 'null') {
        setError('游戏类型信息缺失，请刷新页面重试');
        return;
      }
      
      console.log('🔍 加载游戏类型信息:', gameType);
      
      // 根据游戏类型名称获取详细信息
      const response = await api.get(`/games/types`);
      const gameTypes = response.data;
      
      const foundGameType = gameTypes.find((gt: GameTypeInfo) => 
        gt.name === gameType || gt.display_name === gameType
      );
      
      if (foundGameType) {
        console.log('✅ 找到游戏类型:', foundGameType);
        setGameTypeInfo(foundGameType);
      } else {
        console.error('❌ 未找到游戏类型:', gameType);
        setError(`未找到游戏类型: ${gameType}`);
      }
    } catch (error: any) {
      console.error('加载游戏类型信息失败:', error);
      setError(error.response?.data?.message || '加载游戏类型信息失败');
    } finally {
      setLoading(false);
    }
  };

  const renderGameConfig = () => {
    if (!gameTypeInfo) return null;

    // 根据游戏类型渲染不同的配置组件
    switch (gameTypeInfo.name) {
      case 'ark':
        return <ARKConfig serverId={serverId} gameType={gameTypeInfo.name} serverInfo={serverInfo} onTabChange={onTabChange} />;
      
      // 可以在这里添加其他游戏的配置组件
      // case 'csgo':
      //   return <CSGOConfig serverId={serverId} serverInfo={serverInfo} />;
      // case 'rust':
      //   return <RustConfig serverId={serverId} serverInfo={serverInfo} />;
      
      default:
        return (
          <Card>
            <Alert
              message="暂不支持此游戏的专用配置"
              description={`${gameTypeInfo.display_name} 的专用配置页面正在开发中，请使用通用配置管理。`}
              type="info"
              showIcon
            />
          </Card>
        );
    }
  };

  if (loading) {
    return (
      <Card>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
          <div style={{ marginTop: '16px' }}>加载游戏配置中...</div>
        </div>
      </Card>
    );
  }

  if (error) {
    return (
      <Card>
        <Alert
          message="加载失败"
          description={error}
          type="error"
          showIcon
          action={
            <Button size="small" onClick={loadGameTypeInfo}>
              重试
            </Button>
          }
        />
      </Card>
    );
  }

  return (
    <div>
      {renderGameConfig()}
    </div>
  );
};

export default GameConfig;

